import { render, staticRenderFns } from "./RealTimePresenceSettingMenu.vue?vue&type=template&id=0b2c5a5e"
import script from "./RealTimePresenceSettingMenu.vue?vue&type=script&lang=js"
export * from "./RealTimePresenceSettingMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports